import styled from 'styled-components';

export const ScheduleStyled = styled.div``;
